import React from 'react'
import { Translation, Translator } from '@morningtrain/react-translations'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import { Fieldset } from 'layouts'
import * as Fields from 'support/fields'
import { Repeater } from '@morningtrain/react-fields-repeater-field'
import * as Icons from 'ui/icons'
import {
  ExecuteOperationOnPipe,
  TriggerPipelineOnFormSubmit,
  WhenCaseIs,
  WhenModelValue
} from '@morningtrain/react-resources'
import { SubmitButton } from 'ui'
import { Pipeline } from '@morningtrain/react-helpers'
import { MountSmartviewOnPipe } from '@morningtrain/react-smartviews'
import ButtonWrap from '../../../../ui/layouts/ButtonWrap'
import ViewMessageSmartview from 'widgets/smartviews/hr/messages/ViewMessageSmartview'
import Publish from 'support/actions/messages/Publish'
import UpdateModelOnChange from 'support/utilities/UpdateModelOnChange'
import EditorToolbars from 'support/helpers/EditorToolbars'

export default function EditMessageForm () {
  return (
    <Translator namespace='smartviews.message'>
      <Fieldset>
        <Fields.Input
          name='subject'
          label={<Translation name='fields.subject.label' />}
        />
        <Fieldset cols={2}>
          <UpdateModelOnChange name='type'>
            <Fields.Select
              enum='message_type'
              name='type'
              only={['1', '2', '3']}
              label={<Translation name='fields.type.label' />}
            />
          </UpdateModelOnChange>
          <WhenModelValue name='type' condition='1'>
            <Fields.Checkbox name='is_forced' />
          </WhenModelValue>
          <WhenModelValue name='type' condition='1' negate>
            <input type='hidden' name='is_forced' value={0} />
          </WhenModelValue>
        </Fieldset>
        <Fieldset cols={2}>
          <Fields.Date
            name='show_from'
            label={<Translation name='fields.show_from.label' />}
          />
          <Fields.Date
            name='expires_at'
            label={<Translation name='fields.expires_at.label' />}
          />
        </Fieldset>
        <Fields.Editor
          name='content'
          toolbar={EditorToolbars.BASIC}
          label={<Translation name='fields.content.label' />}
        />
      </Fieldset>

      <SmartviewContentSeparator />

      <Repeater
        name='recipients' draggable={false}
        buttonClass='btn btn-sq btn-primary'
        addLabel={<Icons.Plus className='w-3 h-3' />}
        removeLabel={<Icons.Trash className='w-4 h-4' />}
        label={<Translation name='fields.message_recipients.label' />}
      >
        <Fields.Hidden name='id' />
        <Fields.Switch
          name='type'
          label={<Translation name='fields.message_recipients.labels.recipient_type' />}
          enum='message_recipient_type'
          defaultValue='group'
          placeholder='-'
          only={['user', 'group']}
        >
          <WhenCaseIs value='group'>
            <Fields.ResourceSelector
              name='department_ids'
              optionsKey='name'
              resourceName='departments'
              multiple
              label={<Translation name='fields.department_id.label' />}
              operationName='select'
            />
            <Fields.ResourceSelector
              name='employment_type_ids'
              optionsKey='name'
              multiple
              resourceName='employments.employment_type'
              label={<Translation name='fields.employment_types.label' />}
              operationName='select'
            />
          </WhenCaseIs>
          <WhenCaseIs value='user'>
            <Fields.ResourceSelector
              name='user_ids'
              optionsKey='name'
              resourceName='users.users'
              multiple
              label={<Translation name='fields.user.label' />}
              operationName='select'
            />
          </WhenCaseIs>
        </Fields.Switch>
      </Repeater>

      <ButtonWrap>
        <Publish />
        <SubmitButton>
          <Translation name='generic.save' />
        </SubmitButton>
      </ButtonWrap>

      <Pipeline>
        <TriggerPipelineOnFormSubmit />
        <ExecuteOperationOnPipe operationName='index' />
        <MountSmartviewOnPipe smartview={payload => <ViewMessageSmartview id={payload.data.model.id} />} replace={false} />
      </Pipeline>
    </Translator>
  )
}
